import { Box } from '@mui/material';
import { AppIcon } from 'framework/ui/mui-builder';

const CalendarPrefixIcon = () => (
  <Box display="flex" alignItems="center">
    <AppIcon icon="calendar" sx={{ fontSize: '14px', color: 'text.secondary' }} />
  </Box>
);

export default CalendarPrefixIcon;
